import request from '@/lib/request';
import { formatDataSourceHandle } from '@/lib/utils';
import { sysCaseWays } from '@/constant';

// 获取所有案件列表
export async function getCaseLabelList(params, options) {
  const { includeCleanerFilter = false, recommendField } = options || {};
  // if (params.parentId === 'full_crime_reason') {
  //   params.parentId = 'defendantNames,full_crime_reason';
  // }
  const result = await request.post('/v4/coursewares/page', {
    ...formatDataSourceHandle(params, { includeCleanerFilter }),
    track_total_hits: true
  });
  result.list = result.list.map(item => {
    const relation = (item.relation || []).filter(relationItem => {
      if (recommendField) {
        if (relationItem.labelType !== '推荐' || relationItem.entityLabelId !== recommendField.columnKey) {
          return false;
        }
      } else {
        if (relationItem.labelType === '推荐') {
          return false;
        }
      }
      return true;
    });
    const sourceTemp = {};
    Object.keys(item.caseTag || {}).forEach(columnKey => {
      let tagArr = item.caseTag[columnKey] || [];
      if (!recommendField || recommendField.columnKey === columnKey) {
        tagArr = tagArr.filter(tagItem => {
          if (recommendField) {
            if (tagItem.labelType !== '推荐') {
              return false;
            }
          } else {
            if (tagItem.labelType === '推荐') {
              return false;
            }
          }
          return true;
        });
      }
      sourceTemp[columnKey] = { data: tagArr };
    });
    return { ...item, relation, _source: sourceTemp, caseTag: null };
  });
  return { hits: result.list, caseTotal: result.caseTotal, total: result.total };
}

// 获取案件列表，以标签将每个案件分成几个
export async function getCaseLabelListData(params, options) {
  const { includeCleanerFilter = false } = options || {};
  // if (params.parentId === 'full_crime_reason') {
  //   params.parentId = 'defendantNames,full_crime_reason';
  // }
  return await request.post('/nlp/case/data', {
    ...formatDataSourceHandle(params, { includeCleanerFilter }),
    track_total_hits: true
  });
}

export function getCaseDetail(id) {
  return request.post('/nlp/case/detail', { ids: [id] });
}

export function getDefaultCourseInfo(params) {
  return request.post('/nlp/subject/info', params);
}

export function createCourseBasicInfo(params) {
  if (sysCaseWays.includes(params.instrumentType)) {
    return request.post('/nlp/courseware/framework', params);
  } else {
    return request.post('/v4/administrative/create_courseware', params);
  }
}

export function getRenewProduct(courseId) {
  return request.post('/nlp/case/effect/produce', {
    coursewareId: courseId
  });
}

export function renewCourse(courseId, orderId) {
  return request.post('/nlp/case/order/renew', {
    coursewareId: courseId,
    orderId
  });
}
